module.exports = __webpack_public_path__ + "static/img/6.41063de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/6.png
// module id = 0O0W
// module chunks = 0